import { render } from "./IconEfimovLogo.vue?vue&type=template&id=4871e352"
import script from "./IconEfimovLogo.vue?vue&type=script&lang=js"
export * from "./IconEfimovLogo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__